<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="tools"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="编码">
              <el-input v-model.trim="filter.toolNo" placeholder="请输入编号" clearable/>
            </el-form-item>
            <el-form-item label="名称">
              <el-input v-model.trim="filter.toolName" placeholder="请输入名称" clearable/>
            </el-form-item>
            <el-form-item label="型号">
              <el-input v-model.trim="filter.toolModel" placeholder="请输入型号" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <tool-edit ref="edit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import ToolEdit from "@/views/information/ToolManagement/Tool/ToolEdit";

  export default {
    components: {ToolEdit, ViewTable },
    data() {
      return {
        limits: {
          addAuth: this.$auth(472),
          editAuth: this.$auth(472),
          delAuth: this.$auth(472),
        },
        filter: {
          toolNo: "",
          toolName: "",
          toolModel: "",
        },
        columnsProperty: [
          {
            key: "toolNo",
            align: "center",
            width: 110,
          },
          {
            key: "toolName",
            minWidth: 200,
          },
          {
            key: "toolModel",
            width: 110,
            align: "center",
          },
          {
            key: "note",
            width: 120,
            tooltip: true,
            align: "cnter",
          },
          {
            key: "toolTypeName",
            width: 120,
            tooltip: true,
            align: "center",
          },
          {
            key: "receiverName",
            width: 120,
            align: "center",
          },
          {
            key: "receiveTime",
            width: 120,
            tooltip: true,
          },
          {
            key: "modifierName",
            width: 180,
            tooltip: true,
          },
          {
            key: "modifyTime",
            width: 120,
            tooltip: true,
            align: "center",
          },
          {
            key: "status",
            width: 120,
            tooltip: true,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      addEditHandle(row) {
        this.$refs.edit.open(row);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "tools", row.pkid).then((resp) => {
          console.log(resp);
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>
